import React from 'react';
import styled from '@emotion/styled';
import { Maximize } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation.jsx';

// The map no longer zooms out by itself when nodes arrive (#1431); this puts
// the whole map back in view when someone wants it. Icon only, top-left.
const Button = styled.button`
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 50;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border-radius: 12px;
  background: rgba(20, 20, 31, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.16);
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);

  &:hover { color: #fff; border-color: rgba(255, 255, 255, 0.3); }
`;

export default function ResetZoomButton({ onClick }) {
  const { t } = useTranslation();
  const label = t('impactPath.resetZoom');
  return (
    <Button type="button" onClick={onClick} aria-label={label} title={label}>
      <Maximize size={20} />
    </Button>
  );
}
